export const Dashboard = {
  state: {
    dasboardTasks: [],
    dasboardTasksCursor: ''
  },
  mutations: {
    setDasboardTasks (state, payload) {
      state.dasboardTasks = [...payload]
    },
    
    setDasboardTasksCursor (state, payload) {
      state.dasboardTasksCursor = payload
    },

    setDasboardTaskProperties (state, payload) {
      const { taskIndex, properties } = payload
      const updatedItem = {
        task: {},
        project: {...state.dasboardTasks[taskIndex].project}
      }
      updatedItem.task = Object.assign({}, state.dasboardTasks[taskIndex].task, properties)
      return state.dasboardTasks.splice(taskIndex, 1, updatedItem)
    }
  },
  actions: {
    updateDasboardTasks ({commit}, payload) {
      commit("setDasboardTasks", payload)
    },
    
    updateDasboardTasksCursor ({commit}, payload) {
      commit("setDasboardTasksCursor", payload)
    },

    updateDashboardTaskProperties ({commit, getters}, payload) {
      const {taskId, properties} = payload
      const taskIndex = getters.getDasboardTasks.findIndex(el => el.task.id === taskId)
      if (taskIndex === -1) return false 
      return commit("setDasboardTaskProperties", {taskIndex, properties})
    },

    clearDashboardTasks ({commit}) {
      commit('setDasboardTasksCursor', '')
      return commit('setDasboardTasks', [])
    }
  },
  getters: {
    getDasboardTasks (state) {
      return state.dasboardTasks
    },

    getDasboardTasksCursor (state) {
      return state.dasboardTasksCursor
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Dashboard.js